<template>
  <div class="widget-heading pb-0 d-block">
    <div class="row">

      <div class="col-md-12 col-lg-10">
        <h4 class="d-inline-block h4" style="line-height: 1.4">
          Zestawienia:
        </h4>
      </div>

      <!-- Duży ekran -->
      <div class="col-md-12 btn-group d-none d-md-flex">
        <Link :href="route('kadry.zestawienia.wolne')" class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('kadry.zestawienia.wolne') }">Zestawienia dni wolnych
        </Link>
        <Link :href="route('kadry.karty_ewidencji')" class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('kadry.karty_ewidencji') }">Karty ewidencji
        </Link>
        <Link :href="route('kadry.zestawienia')" class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('kadry.zestawienia') }">Zestawienia etatów
        </Link>
        <Link :href="route('worktime.office.index')" class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('worktime.office.index') }">Czas pracy - ulga
        </Link>
        <Link :href="route('kadry.dyzury.lista')" class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('kadry.dyzury.lista') }">Dyżury
        </Link>
        <Link :href="route('kadry.praca.niedziela.lista')" class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('kadry.praca.niedziela.lista') }">Praca w niedzielę
        </Link>
        <Link :href="route('kadry.odbicia.index')" class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('kadry.odbicia.index') }">Odbicia kart
        </Link>
        <Link :href="route('kadry.pracownicy.telefony')" class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('kadry.pracownicy.telefony') }">Telefony
        </Link>
        <Link :href="route('kadry.pracownicy.okulary')" class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('kadry.pracownicy.okulary') }">Okulary
        </Link>
          <Link :href="route('kadry.pracownicy.lojalki')" class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('kadry.pracownicy.lojalki') }">Lojalki
        </Link>	
          <Link v-if="hasPermission('canViewSMBUsers')" :href="route('kadry.dyski.index')" class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('kadry.dyski.index') }">Dyski sieciowe
        </Link>	
          <Link v-if="hasPermission('canViewERPperms')" :href="route('uprawnienia.erp')" class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('uprawnienia.erp') }">Uprawnienia w ERP
        </Link>	
		</div>

      <!-- Mały ekran -->
      <div class="col-12 d-md-none">
        <div class="dropdown">
          <button
              class="btn btn-outline-primary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
              type="button" @click="toggleDropdown">
            {{ activeLabel }}
            <i class="bi bi-list ms-2"></i>
          </button>
          <div class="dropdown-menu w-100" :class="{ show: isDropdownOpen }">
            <Link :href="route('kadry.zestawienia.wolne')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('kadry.zestawienia.wolne') }">Zestawienia dni wolnych
            </Link>
            <Link :href="route('kadry.karty_ewidencji')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('kadry.karty_ewidencji') }">Karty ewidencji
            </Link>
            <Link :href="route('kadry.zestawienia')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('kadry.zestawienia') }">Zestawienia etatów
            </Link>
            <Link :href="route('worktime.office.index')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('worktime.office.index') }">Czas pracy - ulga
            </Link>
            <Link :href="route('kadry.dyzury.lista')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('kadry.dyzury.lista') }">Dyżury
            </Link>
            <Link :href="route('kadry.praca.niedziela.lista')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('kadry.praca.niedziela.lista') }">Praca w niedzielę
            </Link>
            <Link :href="route('kadry.odbicia.index')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('kadry.odbicia.index') }">Odbicia kart
            </Link>
            <Link :href="route('kadry.pracownicy.telefony')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('kadry.pracownicy.telefony') }">Telefony
            </Link>
            <Link :href="route('kadry.pracownicy.okulary')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('kadry.pracownicy.okulary') }">Okulary
            </Link>
            <Link :href="route('kadry.pracownicy.lojalki')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('kadry.pracownicy.lojalki') }">Lojalki
            </Link>
            <Link v-if="hasPermission('canViewSMBUsers')" :href="route('kadry.dyski.index')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('kadry.dyski.index') }">Dyski sieciowe
            </Link>
            <Link v-if="hasPermission('canViewERPperms')" :href="route('uprawnienia.erp')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('uprawnienia.erp') }">Uprawnienia w ERP
            </Link>
			</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import route from "../../../../../vendor/tightenco/ziggy/src/js/index.js";
import { usePermission } from "@/composables/resources/js/composables/permissions.js";

export default {
  setup() {
    const { hasPermission } = usePermission();

    const isDropdownOpen = ref(false);

    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
    };

    const isRouteActive = (routeName) => {
      return route().current(routeName);
    };

    const labels = {
      "kadry.zestawienia.wolne": "Zestawienia dni wolnych",
      "kadry.karty_ewidencji": "Karty ewidencji",
      "kadry.zestawienia": "Zestawienia etatów",
      "worktime.office.index": "Czas pracy - ulga",
      "kadry.dyzury.lista": "Dyżury",
      "kadry.praca.niedziela.lista": "Praca w niedzielę",
      "kadry.odbicia.index": "Odbicia kart",
      "kadry.pracownicy.telefony": "Telefony",
      "kadry.pracownicy.okulary": "Okulary",
      "kadry.pracownicy.lojalki": "Lojalki",
      "kadry.dyski.index": "Dyski sieciowe",
      "uprawnienia.erp": "Uprawnienia w ERP",
    };

    const activeLabel = computed(() => {
      const current = route().current();
      return labels[current] || "Menu";
    });

    return {
      route,
      hasPermission,
      isRouteActive,
      isDropdownOpen,
      toggleDropdown,
      activeLabel,
    };
  },
};
</script>
